var rcIconButtonWarning = [
    {
        prop: 'autoFocus',
        time: '2021-3',
        comment: "@deprecated don't have any logic below, now need anymore */",
    },
    {
        prop: 'tooltipTitle',
        time: '2021-3',
        comment: "@deprecated tooltip title for the iconButton\n   * please use `title`\n   */",
    },
    {
        prop: 'tooltipPlacement',
        time: '2021-3',
        comment: "@deprecated tooltip placement, default with bottom\n   * please use `TooltipProps` with `placement`\n   */",
    },
    {
        prop: 'disableToolTip',
        time: '2021-3',
        comment: "@deprecated not use ToolTip, default with false\n   * please use `TooltipProps` with `tooltipForceHide`\n   */",
    },
    {
        prop: 'popperProps',
        time: '2021-3',
        comment: "@deprecated popperProps for the icon tooltip\n   * please use `TooltipProps` with `PopperProps`\n   */",
    },
    {
        prop: 'tooltipForceHide',
        time: '2021-3',
        comment: "@deprecated control the tooltip open or not\n   * please use `TooltipProps` with `tooltipForceHide`\n   */",
    },
    {
        prop: 'externalLink',
        time: '2021-3',
        comment: "@deprecated will make iconButton becomes a link, default with false\n   * please write jsx outside by yourself\n   * ```ts\n   * <a rel=\"noopener noreferrer external\" target=\"_blank\" href={href}>\n   *   <RcIconButton .../>\n   * </a>\n   * ```\n   */",
    },
    {
        prop: 'ariaLabel',
        time: '2021-3',
        comment: "@deprecated ariaLabel, when null using tooltipTitle. use 'aria-label' replace */",
    },
    {
        prop: 'download',
        time: '2021-3',
        comment: "@deprecated  make iconButton becomes download button\n   * please write jsx by yourself\n   * ```ts\n   * <a download href={href} ref={aRef}>\n   *   <RcIconButton .../>\n   * </a>\n   * ```\n   */",
    },
    {
        prop: 'buttonRef',
        time: '2021-3',
        comment: "@deprecated ref to the button, please `ref` directly */",
    },
    {
        prop: 'aRef',
        time: '2021-3',
        comment: "@deprecated when download is true, pass the ref to the link\n   * please write jsx by yourself\n   * ```ts\n   * <a download href={href} ref={aRef}>\n   *   <RcIconButton .../>\n   * </a>\n   * ```\n   */",
    },
    {
        prop: 'href',
        time: '2021-3',
        comment: "@deprecated when externalLink or download is true, the link is available\n   * please write jsx by yourself\n   * ```ts\n   * <a download href={href} ref={aRef}>\n   *   <RcIconButton .../>\n   * </a>\n   * ```\n   */",
    },
];
export { rcIconButtonWarning, };
